import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import ServiceSection from './components/ServiceSection';
import FaqSection from './components/FaqSection';

const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d9spapt8o1vn02ekuji0';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <ServiceSection />
        <FaqSection />
      </main>
      <Footer formUrl={NEWSLETTER_FORM_URL} />
    </>
  );
}